import React, {FC} from "react"

import getId from "@irati/utils/id"
import {Deal} from "@irati/types"
import {H2, H3, H5} from "@irati/ui/src/Typography"

import DealModes from "../../enums/DealModes"

import {H4Title, H5Title} from "./styled"

interface Props {
  id?: string,
  deal: Deal,
  mode?: DealModes
}

const UnavailableDealHeaderDetails: FC<Props> = ({deal, mode = DealModes.Default, ...props}) => {
  const isFullPage = mode === DealModes.FullPage
  const isCompact = mode === DealModes.Compact

  return (
    <div>
      {isFullPage && (
        <>
          {deal.brandName && <H3 color="contrast">{deal.brandName}</H3>}
          <H2 id={getId("title", props)} paddingBottom={2} overflowWrap="break-word" marginTop={!deal.brandName && 3}>
            {deal.header}
          </H2>
        </>
      )}
      {!isFullPage && !isCompact && (
        <>
          {deal.brandName && <H5 color="contrast">{deal.brandName}</H5>}
          <H4Title id={getId("title", props)} marginTop={!deal.brandName && 3}>{deal.header}</H4Title>
        </>
      )}
      {!isFullPage && isCompact && (
        <>
          {deal.brandName && <H5 color="contrast">{deal.brandName}</H5>}
          <H5Title id={getId("title", props)} marginTop={!deal.brandName && 3}>{deal.header}</H5Title>
        </>
      )}
    </div>
  )
}

export default UnavailableDealHeaderDetails
